import { createQueryKeys } from '@lukemorales/query-key-factory';
import { PaginationQueryParams, SearchQueryParams } from '@/app/api';
import {
	ClientQueryParams,
	getClient,
	getClientActivityLog,
	getClients,
	getClientSettings,
} from '@/app/api/clients';
import { SingleAdvisor } from '@/app/api/clients/clients.types';

export const clientsKeys = createQueryKeys('clients', {
	list: ({ page, size, advisorId }: PaginationQueryParams & SingleAdvisor) => ({
		queryKey: [{ page, size, advisorId }],
		queryFn: () => getClients({ page, size, advisorId }),
		contextQueries: {
			search: ({ search }: SearchQueryParams) => ({
				queryKey: [{ page, size, search, advisorId }],
				queryFn: () => getClients({ page, size, search, advisorId }),
			}),
		},
	}),
	single: ({ clientId }: ClientQueryParams) => ({
		queryKey: [clientId],
		queryFn: () => getClient({ clientId }),
		contextQueries: {
			settings: () => ({
				queryKey: [clientId],
				queryFn: () => getClientSettings({ clientId }),
			}),
			activityLog: () => ({
				queryKey: [clientId],
				queryFn: () => getClientActivityLog({ clientId }),
			}),
		},
	}),
});
